var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_4130_76309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 33.7492H6.125C3.32562 33.7492 0.5 31.623 0.5 26.8755V17.4255C0.539426 13.117 2.15267 8.97167 5.03596 5.76998C7.91924 2.56829 11.8736 0.53121 16.1544 0.0423369C18.5701 -0.133024 20.9952 0.213677 23.2649 1.05888C25.5347 1.90409 27.596 3.22799 29.3086 4.94062C31.0212 6.65326 32.3451 8.7145 33.1903 10.9843C34.0355 13.254 34.3822 15.6792 34.2069 18.0948C33.7174 22.3774 31.6786 26.333 28.4746 29.2165C25.2706 32.1 21.1228 33.7121 16.8125 33.7492ZM38 17.0242H37.9775C37.9775 17.4686 37.9775 17.913 37.955 18.3592C37.2313 28.4992 27.9631 37.083 17.5325 37.4636V37.4917C18.8461 39.77 20.7357 41.663 23.0117 42.9806C25.2877 44.2983 27.8701 44.9944 30.5 44.9992H39.875C41.3668 44.9992 42.7976 44.4066 43.8525 43.3517C44.9074 42.2968 45.5 40.8661 45.5 39.3742V29.9992C45.4973 27.3688 44.8029 24.7853 43.4865 22.5079C42.1701 20.2306 40.278 18.3394 38 17.0242Z",
    fill: "#00FFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_76309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.aec6604c214bd9fc650569ca4f659f46.svg";
export { ForwardRef as ReactComponent };